// extracted by mini-css-extract-plugin
export default {"list":"UsersList_list__8Q7At"};